import { createStore } from 'vuex';
import axios from 'axios';

// Ensure Axios hits your API host in prod
const API = process.env.VUE_APP_API_URL || window.__APP_CONFIG__?.API_URL || '';
if (API) axios.defaults.baseURL = API;

const store = createStore({
  state: {
    isAuthenticated: false,
  },
  mutations: {
    setAuthentication(state, status) {
      state.isAuthenticated = status;
    },
  },
  actions: {
    async login({ commit }, { email, password, redirect = '/shop' }) {
      try {
        const { data } = await axios.post(
          `/api/retailer/login?redirect=${encodeURIComponent(redirect)}`,
          { email, password }
        );

        const { token, cid, squareCustomerId } = data || {};
        if (!token || !cid) throw new Error('Missing token or cid');

        // Persist auth
        localStorage.setItem('accessToken', token);
        localStorage.setItem('cid', cid);
        localStorage.setItem('squareCustomerId', squareCustomerId);

        // Default headers for future calls
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        axios.defaults.headers.common['cid'] = cid;

        commit('setAuthentication', true);
      } catch (error) {
        console.error('Login failed:', error);
        commit('setAuthentication', false);
        throw error;
      }
    },

    async logout({ commit }) {
      try {
        await axios.post('/api/logout');
        localStorage.removeItem('accessToken');
        localStorage.removeItem('cid');
        localStorage.removeItem('squareCustomerId');
        localStorage.removeItem('userEmail');
        delete axios.defaults.headers.common['Authorization'];
        delete axios.defaults.headers.common['cid'];
        commit('setAuthentication', false);
      } catch (error) {
        console.error('Logout failed:', error);
      }
    },

    checkAuthentication({ commit }) {
      // Restore auth from localStorage
      const token = localStorage.getItem('accessToken');
      const cid = localStorage.getItem('cid');
      const isAuthed = !!(token && cid);

      if (isAuthed) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        axios.defaults.headers.common['cid'] = cid;
      } else {
        delete axios.defaults.headers.common['Authorization'];
        delete axios.defaults.headers.common['cid'];
      }

      commit('setAuthentication', isAuthed);
    },
  },
});

export default store;
